import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../services/api';
import { monitorSession } from '../services/sessionLifecycle';

export function SessionMonitor() {
  const { user } = useAuth();
  useEffect(() => {
    if (user) return monitorSession(authApi);
  }, [user]);
  return null;
}
